<template>
  <div :style="{ 'background-image': `url(${ImageLogo})` }" class="loginLogo"
    style="height: 100%; display: flex; flex-direction: column;">
    <div style="height: 100%; display: flex; justify-content: center">
      <div class="kp">
        <h1 style="text-align: center; font-weight: 100; margin-bottom: 30px">
          {{ titelyu }} <a style="opacity: 0;" @click="() => {
            numshuru++
            if (numshuru > 5) {

              fromlogin.name = '前台测试用户'
              fromlogin.password = '123456'
            }
          }">1</a>
        </h1>
        <!-- 输入框 -->

        <div v-if="!noShow" class="login-fle">
          <div style="margin-bottom: 20px">
            <el-input @keyup.enter.native="logina" v-model="fromlogin.name" placeholder="请输入用户名" />
          </div>
          <div>
            <el-input @keyup.enter.native="logina" v-model="fromlogin.password" type="password" placeholder="请输入密码"
              show-password />
          </div>
          <p style="
              display: flex;
              justify-content: flex-end;
              font-size: 12px;
              margin-bottom: 15px;
            ">
            没有账户？
            <router-link to="/zuce" tag="div">
              <span style="margin: 0; color: rgb(102, 177, 255)" class="active-link">立即注册</span>
            </router-link>
          </p>
          <!-- 按钮 -->

          <el-button style="width: 100%" color="#067af5" @click="logina" type="primary"><span>登录</span></el-button>
          <el-button v-if="userSet.is_trial_price == 2" style="width: 100%;margin-left: 0;margin-top: 20px; "
            @click="Trialpricecalculation"><span>试算价格</span></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getConfig, indexout } from "@/api/user";
export default {
  name: "ShipeaseFrontDeskLoginA",

  data() {
    return {
      ImageLogo: '',
      userSet: {},
      hdidnext: 0,
      numshuru: 0,
      yuming: "",
      titelyu: "",
      fromlogin: {
        name: "",
        password: "",
      },
      tokenKey: "",
      sessIStrue: false,
      noShow: false,
    };
  },
  watch: {
    $route: {
      //执行 val:当前最新值 old:上一刻的值
      handler: function (val, old) {
        if (val.query.moni == 2) {
          this.fromlogin.name = val.query.name;
          this.fromlogin.password = val.query.password;
        }
      },
      // 立即处理 进入页面就触发
      immediate: true,
      // 深度监听 属性的变化
      deep: true,
    },
  },
  created() {
    this.yuming = document.domain;
    this.indexouta(this.yuming);
  },
  mounted() {
    // if (this.$route.params.pass) {
    //   this.fromlogin.name = this.$route.params.uname
    //   this.fromlogin.password = this.$route.params.pass
    // }

  },
  methods: {
    Trialpricecalculation() {
      let routeData = this.$router.resolve({
        name: "Trialpricecalculation",
        query: {
          hdid: this.hdidnext
        },
      });
      window.open(routeData.href, "_blank");
    },
    //系统基础信息
    async indexouta(val) {
      try {
        let res = await getConfig({ yuming: val });
        if (res.code == 200) {
          this.ImageLogo = res.data.image
          this.userSet = res.data
          document.title = res.data.sysname;
          this.titelyu = res.data.sysname;
          this.hdidnext = res.data.id;
        } else {
          if (res?.code == 400 && res.data == "1") {
            this.noShow = true;
            this.$alert(res.msg, "温馨提示", {
              confirmButtonText: "点击跳转到官网",
              callback: (action) => {
                if (action == "confirm") {
                  window.location.href = "https://www.shipOS.cn";
                }
              },
            });
          }
        }
      } catch (error) { }
    },
    //本地登陆
    async logina() {
      for (let key in this.fromlogin) {
        if (!this.fromlogin[key]) {
          this.$message.error("请输入正确的账户或密码");

          return;
        }
      }
      let data = {
        uname: this.fromlogin.name,
        pass: this.fromlogin.password,
        yuming: this.yuming,
      };
      let res = await login(data);
      if (res.code == 200) {
        this.tokenKey = res.data.token;
        this.$store.commit('tokenui', res.data.token)
        window.localStorage.setItem("token", this.tokenKey);
        let user = await indexout();
        window.localStorage.setItem("menu", JSON.stringify(user.data.menu));
        window.localStorage.setItem("setuser", JSON.stringify(user.data));
        this.$router.replace({ path: "index/kzt" });
        this.fromlogin.name = "";
        this.fromlogin.password = "";
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.loginLogo {
  background-size: cover;
  background-position: center;
  text-align: center;
}

.active-link {
  cursor: pointer;
}

.kp {
  width: 550px;
  margin-top: 200px;
  height: max-content;
  padding: 40px 0;
  padding-bottom: 55px;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.3);
  /* 半透明背景 */
  backdrop-filter: blur(10px);
  /* 模糊效果 */
  -webkit-backdrop-filter: blur(10px);
  /* 兼容 Safari */
  border-radius: 10px;
  /* 可选：圆角 */
  border: 1px solid rgba(255, 255, 255, 0.2);
  /* 可选：边框 */
}

.login-fle {
  width: 70%;
  margin: 0 auto;

  // padding: 16px;
  div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  span {
    margin: 0 100px;
  }

  .item-e {
    height: 100%;
    position: relative;

    .imga {
      position: absolute;
      right: 0;
      top: 1px;
      height: 30px;
    }
  }
}
</style>
